// extracted by mini-css-extract-plugin
export var buttons = "Contact-module--buttons--ae253";
export var contact = "Contact-module--contact--f0b32";
export var container = "Contact-module--container--76028";
export var darkTheme = "Contact-module--darkTheme--e4971";
export var irImage = "Contact-module--irImage--2a53d";